import { render, staticRenderFns } from "./ShortArticleCard.vue?vue&type=template&id=7bf949ab&"
import script from "./ShortArticleCard.vue?vue&type=script&lang=js&"
export * from "./ShortArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports